

define(['angular', 'squid/index', './directive'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-route-to-complete', ['squid', 'xo-route-to-complete.directive']).factory('$RouteToCompleteRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('RouteToCompleteRoute', {
            name: 'routeToComplete',
            directive: 'xo-route-to-complete',
            titleContent: 'genericError.pleaseTryAgain',
            query: ['url', 'urlType'],
            trackingData: {
                fptiState: 'route-to-complete',
                buzname: {
                    'fullpage': {
                        'pagename': '%::route-to-complete',
                        'pagename2': '%::route-to-complete:member:hermes:',
                        'version': 'member:%:'
                    }
                }
            },

            children: []
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/route-to-complete/route.js
// module id = ./components/xo-page-components/src/route-to-complete/route.js
// module chunks = 1